import { render, staticRenderFns } from "./ws-theme-card.vue?vue&type=template&id=e1620e30&"
import script from "./ws-theme-card.vue?vue&type=script&lang=js&"
export * from "./ws-theme-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports